import { render } from "./zaku-product-requests-uploader.vue?vue&type=template&id=5a3b4699&scoped=true"
import script from "./zaku-product-requests-uploader.vue?vue&type=script&lang=js"
export * from "./zaku-product-requests-uploader.vue?vue&type=script&lang=js"

import "./zaku-product-requests-uploader.vue?vue&type=style&index=0&id=5a3b4699&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a3b4699"]])

export default __exports__